import { __rest } from "tslib";
import React from 'react';
import cn from 'classnames';
import { motion } from 'framer-motion';
import Animated, { AnimationType } from '../Animated';
import styles from './AnimatedListItem.module.scss';
const AnimatedListItem = (_a) => {
    var { className, onClick, id, children } = _a, props = __rest(_a, ["className", "onClick", "id", "children"]);
    return (React.createElement(Animated, Object.assign({ Component: motion.li, animation: AnimationType.falling, initial: "hidden", animate: "visible", onClick: onClick, key: `item_${id}`, className: cn(styles.item, className) }, props), children));
};
export default AnimatedListItem;
//# sourceMappingURL=AnimatedListItem.js.map